export default __webpack_public_path__ + "static/media/quiz-background-right.d9d58b46.jpg";